import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";
import { MedicalPaOrder } from "../../../../../data-model/medicalPaOrdersModel";
import { CptCodeWithDetailsKeys } from "../../../../../enums/tableColumnKeys";
import { updateTableDataState } from "./updateTableDataState";

export const handleValueChangeOfTextField = (
  value: string,
  id: string,
  fieldKey: string,
  tableData: CptCodesTableRowModel[],
  originalTableData: CptCodesTableRowModel[],
  setTableData: React.Dispatch<React.SetStateAction<CptCodesTableRowModel[]>>,
  setHasChanges: React.Dispatch<React.SetStateAction<boolean>>,
  saveTableDataToLocalStorage: (data: CptCodesTableRowModel[]) => void,
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const findRowIndex = tableData.findIndex((row) => row.jCodeId === id);
  if (findRowIndex !== -1) {
    updateTableDataState(
      findRowIndex,
      CptCodeWithDetailsKeys.JCodes,
      value,
      singleMedicalPaOrder ?? {},
      originalTableData,
      setTableData,
      setHasChanges,
      saveTableDataToLocalStorage,
    );
  }
};
